import logo from './logo.svg';
import './App.css';
import React from 'react';
import {BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import HomePage from './screens/HomePage';
import NavBar from './components/NavBar';
import PricingPage from './screens/PricingPage';
import ApplyPage from './screens/ApplyPage';
import DriversPage from './screens/DriversPage';
import ContactPage from './screens/ContactPage';
import OTPInput from "otp-input-react";
import GizlilikPage from './screens/Gizlilik';
import CookiePage from './screens/CookiePage';
import UserPage from './screens/UserPage';
import QuotePage from './screens/QuotePage';
import FAQ from './screens/FAQ';
import OrderPage from './screens/OrderPage';
import AboutUsPage from './screens/AboutUsPage';
import BookPage from './screens/BookPage';
import API, { user } from './API';
import BookingsPage from './screens/BookingsPage';
import BookingDetailsPage from './screens/BookingDetailsPage';
import { GiftedChat } from 'react-gifted-chat';
import styles from "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageInput,
} from "@chatscope/chat-ui-kit-react";


import { Widget } from 'react-chat-widget';
import 'react-chat-widget/lib/styles.css';

var userHTML = "";
export default class App extends React.Component {
  constructor() {
    super();

    this.state = {loginModalOpen: false, promptState: 0, tel:"", otp:"", name: "", email: "",loading: false, openChatMessages: [], liveChatOpened: false};
    
    global.promptLogin = (loginCallback) => {
      this.loginCallback = loginCallback;
      this.setState({loginModalOpen: true, promptState: 0, tel:"",otp:"", name: "", email: ""});
    }
  
    var loginToken = localStorage.getItem("clientToken");
    if(loginToken) {
      this.state.loading = true;

      API.fetchClient("token", {token: loginToken}).then((val) => {
        if(val.error) {
          localStorage.removeItem("clientToken");
          this.setState({loading: false});
          
        } else {
          
          this.state.loading = false;

          API.setLogin(val.token, val.user);

          if(val.termsAndConditions) {
            this.setState({promptState: 2,loginModalOpen: true});
          } else if(!val.user.name) {
            this.setState({promptState: 3,loginModalOpen: true});
          } else {
            this.forceUpdate();
          }
        }

        
      })
    }
  }

  render() {

    if(this.state.loading) {
      return <div style={{position:"absolute",left:0,right:0,top:0,bottom:0,backgroundColor:"white", display:"flex",justifyContent:"center",alignItems:"center"}}>
        <div className="loading-spinner-big">
      
      </div>
      </div>
    }
    return (
      <div>
      <Router>
        
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/pricing' element={<PricingPage />} />
          <Route path='/apply/:id' element={<ApplyPage />} />
          <Route path='/apply' element={<ApplyPage />} />
          <Route path='/driver' element={<DriversPage />} />
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/gizlilikpolitikasi' element={<GizlilikPage />} />
          <Route path='/cerezpolitikasi' element={<CookiePage />} />
          <Route path='/kullanicisozlesmesi' element={<UserPage />} />
          <Route path='/hesapla' element={<QuotePage />} />
          <Route path='/sss' element={<FAQ />} />
          <Route path='/siparis/:id' element={<OrderPage />} />
          <Route path='/hakkimizda' element={<AboutUsPage />} />
          <Route path='/siparis' element={<BookPage />} />
          <Route path='/siparislerim' element={<BookingsPage />} />
          <Route path='/siparisim/:id' element={<BookingDetailsPage />} />
        </Routes>
      </Router>

      
  
      <div className={'loginModalRoot'+(this.state.loginModalOpen?" open":"")}>
        {this.state.promptState == 0 && <div className='loginModalPhone'>
          <p className='loginTitle'>Taşımacım'a giriş yap</p>
          <p className='loginAlt'>Telefon numaranızı girin</p>

          <div style={{display:"flex",gap:10, flex:1}}>
          <div className='phoneInput' style={{width:"fit-content", pointerEvents:"none"}}>+90</div>
          <input onChange={(x) => {
             var e = x.target.value.replace(/ /g, "");
             var newPhone = "";
             for(var i = 0; i < e.length; i++) {
                 if(i == 3 || i == 6 || i == 8) newPhone += " ";


                 newPhone += e[i];
             }
             this.setState({tel:newPhone})
          }} value={this.state.tel} type={'tel'} style={{flex:1}} placeholder='500 000 00 00' className='phoneInput' />
          </div>

          <button onClick={() => {
            this.setState({promptState: -1});
            API.fetchClient("requestcode", {phone: this.state.tel.replace(/ /g, "")}).then((val) => {
              
              if(val.error) {
                this.setState({promptState:0});
              } else {
                this.setState({promptState: 1});
              }
            })
          }} disabled={this.state.tel.replace(/ /g, "").length != 10} className='loginContinueButton'>Devam</button>
          </div>}

          {this.state.promptState == 1 && <div style={{width:"fit-content"}} className='loginModalPhone'>
          <p className='loginTitle'>OTP doğrulaması</p>
          <p className='loginAlt'>+90 {this.state.tel} telefon numarasına gelen 4 haneli kodu girin</p>
          <OTPInput inputClassName='otpInput' value={this.state.otp} onChange={(e) => {
            
            if(e.length == 4) {
              this.setState({promptState:-1});

              API.fetchClient("login", {phone: this.state.tel.replace(/ /g, ""), code: e}).then((val) => {
                
                if(!val.error) {
                  localStorage.setItem("clientToken", val.token);
                  API.setLogin(val.token, val.user);
                  if(val.termsAndConditions) {
                    this.setState({promptState: 2});
                  } else if(!val.user.name) {
                    this.setState({promptState: 3});
                  } else {
                    this.finishSigningProcess();
                  }
                } else {
                  this.setState({promptState: 1});
                }
              })
            } else {
              this.setState({otp:e})
            }
            
          }} autoFocus={true} OTPLength={4} otpType="number" disabled={false} />
          </div>}

          {this.state.promptState == 2 && <div className='loginModalPhone agreementModal' style={{display:"flex",flexDirection:"column"}}>
            
              {/* <div style={{overflowY:"scroll", width:"50%", height:"50%"}} dangerouslySetInnerHTML={{__html: (() => {

                if(userHTML) return userHTML;

                fetch("/mobileuseragreement.html").then((e) => e.text()).then((e) => {
                  userHTML = e;
                  this.forceUpdate();
                })
                return "";

              })()}}></div> */}
              <p className='loginTitle'>Kullanıcı sözleşmemiz güncellendi</p>
              <p className='loginAlt'>Lütfen kullanıcı sözleşmemizi okumaya zaman ayırın</p>
              <div style={{display:"flex",flex:1}}><iframe src='/mobileuseragreement.html' style={{width:"100%",height:"100%",outline:"none", border:"none"}} /></div>
              
              <button onClick={() => {
                    this.setState({promptState:-1})
                    API.fetchClient("signtos").then((e) => {
                      if(e.error) {
                        return this.setState({promptState:2});
                      }

                      if(API.user.name) {
                        this.finishSigningProcess();
                      } else {
                        this.setState({promptState:3});
                      }
                    })
                }} disabled={false} className='bookButton' style={{marginTop:20}}>Kabul Et</button>
          </div>}

          {this.state.promptState == 3 && <div className='loginModalPhone'>
          <p className='loginTitle'>Üyeliğinizi oluşturun</p>
              <p className='loginAlt'>Üyelik oluşturmanın son aşamasında bazı üyelik bilgilerini doldurmanı istiyoruz</p>

              <input className='bookingInput' value={this.state.name}  onChange={(e) => {this.setState({name: e.target.value})}} placeholder={"Ad Soyad"} type={'text'}  />
              <input className='bookingInput' value={this.state.email}  onChange={(e) => {this.setState({email: e.target.value})}} placeholder={"E-posta (Opsiyonel)"} type={'email'} style={{marginTop:20}}  />

              <button onClick={() => {
                    this.setState({promptState:-1})
                    API.fetchClient("updateinfo", {name: this.state.name, email: this.state.email, lang: "tr"}).then((e) => {
                      if(e.error) {
                        return this.setState({promptState:3});
                      }
                      API.user.name = this.state.name;
                      API.user.email = this.state.email;
                      this.finishSigningProcess();
                    })
                }} disabled={this.state.name.trim().length <= 3} className='bookButton' style={{marginTop:20}}>Kaydet ve Bitir</button>
            </div>}

          {this.state.promptState == -1 && <div>
            
            <div className="loading-spinner-big">
      
    </div>
          </div>}

            
          
      </div>
      {/* <div style={{position:"fixed",right:10, bottom: 10,zIndex:1000,width:100, height:100}}>
        <Widget  />
        </div> */}

{/* <div className='liveChatButton' onClick={() => {
  this.setState({liveChatOpened: !this.state.liveChatOpened});
}} >
            <div onClick={(e) => e.stopPropagation()} className={'chatMainContainer ' + ((this.state.liveChatOpened)?"enabled":"")}>
            <MainContainer>
    <ChatContainer>
      <MessageList>
        <Message
          model={{
            message: "Hello my friend",
            sentTime: "just now",
            sender: "Joe",
          }}
        />
        {this.state.openChatMessages.map((x, i) => <Message model={{message: x.m, sentTime: x.d, direction:x.p?"incoming":"outgoing"}} key={i} />)}
      </MessageList>
      <MessageInput onSend={(m) => {
          console.log(m);

          this.state.openChatMessages.push({m,d: Date.now(),p:false});
          this.forceUpdate();
      }} placeholder="Type message here" />
    </ChatContainer>
  </MainContainer>
            </div>
        </div> */}

        
      </div>
    );
  }

  finishSigningProcess() {
    this.setState({loginModalOpen: false});

    if(this.loginCallback) this.loginCallback();
  }
}

